import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const headerLinks = [
  {
    label: "Home",
    path: "/",
  },
  {
    label: "About us",
    path: "/aboutus",
  },
  {
    label: "Privacy Policy",
    path: "/privacy-policy",
  },
  {
    label: "Get Hired",
    path: "/apply-for-job",
  },
  {
    label: "Services",
    path: "/services",
  },
  {
    label: "Contact Us",
    path: "/contactus",
  },
];



const Header = () => {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuButtonRef = useRef(null); // Reference for the menu/hamburger button
  const mobileMenuRef = useRef(null); // Reference for the mobile menu

  // Toggle function for the mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close the mobile menu when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        menuButtonRef.current &&
        !menuButtonRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // cleanup function to remove the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  return (
    <header
      className="flex justify-between items-center p-5 text-white"
      style={{
        background:
          "linear-gradient(135deg, #191c33 35%, #111743 65%)",
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        zIndex: "1000", // ENSURES THE HEADER IS ALWAYS ON TOP OF OTHER CONTENTS
      }}
    >
      {/* Header logo */}
      <div className="logo">
        <Link to= "/">
          <img
            src="/logo.png"
            alt="Logo"
            height={28}
            width={98}
          />
        </Link>
      </div>

      {/* Desktop Navigation */}
      <div 
        className="justify-between gap-8 hidden lg:flex"
        style={{ fontSize: "25px", fontWeight: "bold" }}
      >
        {headerLinks.map((link, index) => {
          return (
            <ul
              key={index}
              className="text-slate-400 hover:text-gray-300 mx-4"
            >
              <Link to={link.path}>{link.label}</Link>
            </ul>
          );
        })}
      </div>

      {/* Hamburger/Menu Icon */}
      <div className="lg:hidden">
        <button ref={menuButtonRef} onClick={toggleMenu}>
          {isMenuOpen ? (
            <FaTimes className="text-white text-2xl" />
          ) : (
            <FaBars className="text-white text-2xl" />
          )}
        </button>
      </div>

      {/* Mobile menu */}
      <div
        ref={mobileMenuRef}
        className={`lg:hidden absolute top-0 right-0 w-2/3 h-50 bg-[#29313F] p-5 transform transition-transform duration-300 ${
          isMenuOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{ borderRadius: "20px" }}
      >
        {/* Cancel Icon to close the menu */}
        <button
          onClick={toggleMenu}
          className="absolute top-4 right-4 text-white text-3xl"
        >
          <FaTimes />
        </button>

        {/* Mobile Navigation Links */}
        <nav>
          {headerLinks.map((link, index) => (
            <ul
              key={index}
              className="flex flex-col p-0 space-y-4 font-bold text-white hover:text-gray-300 text-xl mb-4"
            >
              <Link to={link.path} onClick={toggleMenu}>
                {link.label}
              </Link>
            </ul>
          ))}
        </nav>

      </div>
    </header>
  );
};

export default Header;
